module.exports = __webpack_public_path__ + "static/media/loading.9ab97c7a.gif";